import { createFileRoute } from "@tanstack/react-router";

import SolutionDetailPage from "@/features/public/pages/solution-detail";

function SolutionDetailRoute() {
  const { productId } = Route.useParams();
  return (
    <main role="main" aria-label="Solution detail" className="min-h-screen w-full">
      <SolutionDetailPage productId={productId} />
    </main>
  );
}

export const Route = createFileRoute("/(public)/_public/solutions/$productId")({
  component: SolutionDetailRoute,
});
